import ModelFactory from 'business/models/ModelFactory';
import {
  SearchClient,
  SearchResultsDTO,
  SearchDetailDTO,
  SearchItemsTarget,
  RecentSearchDTO,
} from 'business/models/Models';
import BaseService from './BaseService';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import {
  SearchBarFilters,
  SearchResult,
  RecentSearchResult,
  toSearchDetailDTO,
} from 'components/main/tree/SearchBar/Context/types';
import { getSearchResultEntityId } from 'transformers/searchnFilter';

export default class SearchService extends BaseService {
  async Search(
    searchQuery: string,
    searchTarget: SearchItemsTarget[],
  ): Promise<SearchResultsDTO[]> {
    const searchClient: SearchClient = ModelFactory(SearchClient, false, true);
    const searchDetails = new SearchDetailDTO();
    searchDetails.searchQuery = searchQuery;
    searchDetails.searchTarget = searchTarget;

    return await searchClient.search(searchDetails);
  }

  async SearchWithFilters(
    filters: SearchBarFilters,
    limit?: number,
    signal?: AbortSignal,
  ): Promise<SearchResult[]> {
    const searchClient: SearchClient = ModelFactory(SearchClient, false, false, signal);
    const searchDetails = toSearchDetailDTO(filters, limit);

    const response: SearchResultsDTO[] = await searchClient.search(searchDetails);
    return response.map((r) => ({
      name: r.fileName,
      type: r.type as ETreeNodeTypes,
      nodeId: r.treeNodeId,
      containerNodeId: r.containerNodeid,
      entityId: getSearchResultEntityId(r),
      plates: r.experimentInfo?.plates,
      status: r.synchrotronTripInfo?.status,
      state: r.experimentInfo?.state,
      datePrepared: r.datePrepared,
      owner: r.owner,
    }));
  }

  async GetRecentSearches(): Promise<RecentSearchResult[]> {
    const searchClient: SearchClient = ModelFactory(SearchClient);
    const response: RecentSearchDTO[] = await searchClient.getRecentSearches();
    return response.map((r) => ({
      id: r.id,
      searchDetail: r.searchDetail,
      searchDate: r.searchDate.toISOString(),
    }));
  }

  async RecordRecentSearch(searchDetail: SearchDetailDTO): Promise<void> {
    const searchClient: SearchClient = ModelFactory(SearchClient);
    return await searchClient.recordRecentSearch(searchDetail);
  }
}
